import { isAnalyticsEnabled } from './utils'

export function rdt(type, metadata = {}) {
  if (!isAnalyticsEnabled()) return
  // @ts-ignore
  if (window.rdt) {
    // @ts-ignore
    window.rdt('track', type, metadata)
  }
}
